export enum EPageType {
  Home = 'Home',
  Collection = 'Collection',
  LandingPage = 'Landing Page',
  Blog = 'Blog',
  SizeChart = 'Size Chart',
  Product = 'Product',
  Checkout = 'Checkout',
  Account = 'Account',
  OtherCoolmate = 'Other Coolmate',
  Search = 'Search',
  Cart = 'Cart',
  Spotlight = 'Spotlight',
}

export enum ETrackingEvent {
  ClearEcommerce = 'clear_ecommerce',
  PageView = 'pageview',
  UserLogin = 'user_login',
  UserLogout = 'user_logout',
  UserRegister = 'user_register',
  // ViewListItem = 'view_item_list',
  SelectItem = 'select_item',
  ViewItem = 'view_item',
  AddToCart = 'add_to_cart',
  RemoveFromCart = 'remove_from_cart',
  BeginCheckout = 'begin_checkout',
  Purchase = 'purchase',
  PaymentSuccess = 'payment_success',
  // PageView = 'page_view',
  SearchNoResults = 'search_no_results',
  ProductNotFound = 'product_not_found',
  CollectionNotFound = 'collection_not_found',
  // CoolxprintRequested = 'coolxprint_requested',

  //Product_Detail
  // Tracking suggest
  ViewSuggestionProduct = 'view_suggestion_product', //Gợi ý sản phẩm tương tự
  ViewSuggestionStyle = 'view_suggestion_style', // Mua sắm theo phong cách
  ViewSuggestionSimilar = 'view_suggestion_similar', //Sản phẩm cùng công nghệ
  ClickSuggestedProduct = 'click_suggested_product',

  //Coolxprint
  Conversion = 'conversion',
  SubmitOct = 'submit_oct',
  Remarketing = 'remarketing',
  FormSubmissionSuccess = 'formSubmissionSuccess',

  //Custom
  GoodPrice = 'goodprice',
  ClickTracking = 'click_tracking',
}

export type TTrackingEcommerce = {
  item_list_id: string
  item_list_name: string
  product_id: string
  product_name: string
  product_quantity: number
  product_group: string
  product_variant: string
  product_discount: number
  product_coupon: string
  product_review: number
  product_rating: number
  unique_event_id: string
  items: [
    {
      item_id: string
      item_name: string
      coupon: string
      discount: number
      item_brand: string
      item_category: string
      item_category2: string
      item_category3: string
      item_list_id: string
      item_list_name: string
      item_variant: string
      price: number
      quantity: number
    },
  ]
}

export type TTrackingBeginCheckout = {
  currency: string
  value: number
  original_price: number
  item_list_id: string
  item_list_name: string
  product_id: string
  product_name: string
  product_quantity: number
  product_group: string
  product_variant?: string
  product_discount: number
  product_coupon: string
  product_review: number
  product_rating: number
  unique_event_id: string
  items: [
    {
      item_id: string
      item_name: string
      coupon: string
      discount: number
      item_brand: string
      item_category: string
      item_category2: string
      item_category3: string
      item_list_id: string
      item_list_name: string
      item_variant: string
      price: number
      quantity: number
    },
  ]
}
